import { Fragment, useState } from 'react'

import Link from 'next/link'

import { Dialog, Transition } from '@headlessui/react'
import 'swiper/css'
import 'swiper/css/navigation'
import { Swiper, SwiperSlide } from 'swiper/react'

import { AppImage } from '~/components/data-display/AppImage'
import { config } from '~/config'

import { CloseIcon } from '../../icons'

type Props = {
  thumbnailImages: string[]
  users: ImageModalUser[]
  visitedDates: (string | undefined)[]
  imageIndex: number
  isOpen: boolean
  onClose: () => void
}

export interface ImageModalUser {
  nickname: string | undefined
  userName: string | undefined
  attribute: string | undefined
  imageUrl: string | undefined
}

export const formatVisitedDate = (visitedDate: string | undefined) => {
  if (!visitedDate) return undefined
  const date = new Date(visitedDate)
  return `${date.getFullYear()}年${date.getMonth() + 1}月`
}

const ImageModal = (props: Props) => {
  const [page, setPage] = useState(props.imageIndex)
  return (
    <div>
      <Transition appear show={props.isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={props.onClose}>
          <div className="fixed inset-0">
            <div className="flex items-center justify-center min-h-full text-center">
              <Transition.Child as={Fragment}>
                <Dialog.Panel className="h-screen flex items-center bg-[#434343]">
                  <div>
                    <div className="max-w-lg pr-4 mx-auto mb-2 text-right">
                      <button
                        type="button"
                        onClick={() => props.onClose()}
                        className="outline-none"
                      >
                        <CloseIcon className="fill-white w-[14px] h-[14px]" />
                      </button>
                    </div>
                    <div>
                      <div className="h-[325px] w-screen">
                        <Swiper
                          initialSlide={page}
                          onActiveIndexChange={(swiper) => {
                            setPage(swiper.realIndex)
                          }}
                        >
                          {props.thumbnailImages.map((image, i) => (
                            <SwiperSlide
                              className="inline-flex justify-center"
                              key={`image-${i}`}
                            >
                              <div className="max-w-lg">
                                <img
                                  className="max-h-[325px] "
                                  src={image}
                                  alt={`投稿画像-${i}`}
                                />
                              </div>
                            </SwiperSlide>
                          ))}
                        </Swiper>
                      </div>

                      <div className="flex flex-col max-w-lg mx-auto">
                        <div className="flex items-center px-4 mt-4 text-sm text-white">
                          <Link
                            href={`/foodies/${props.users[page]?.userName}`}
                          >
                            {/* TODO: Use the profile variant */}
                            <AppImage
                              variant={{
                                type: 'cover',
                                coverPosition: 'center',
                              }}
                              rounded="full"
                              width={40}
                              height={40}
                              alt="image"
                              className="object-cover rounded-full"
                              src={{
                                try: props.users[page]?.imageUrl,
                                fallback: config.noImageUrl.userProfileIcon,
                              }}
                            />
                          </Link>
                          <div className="text-left">
                            <div className="ml-2 font-bold">
                              {props.users[page]?.nickname}
                              <span className="ml-1 text-xs font-normal">
                                @{props.users[page]?.userName}
                              </span>
                            </div>
                            <div className="mt-1">
                              {props.users[page]?.attribute}
                            </div>
                          </div>
                          <div className="ml-auto">
                            {props.visitedDates[page]
                              ? props.visitedDates[page] + 'に訪問'
                              : ''}
                          </div>
                        </div>

                        <div className="px-10 mt-6">
                          <button
                            type="button"
                            className="bg-[#E6E6EA] text-black font-bold w-full py-2 rounded-md"
                            onClick={() => props.onClose()}
                          >
                            閉じる
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  )
}
export { ImageModal }
